export const USER_ROLES = {
  BROKER: 'Corretor',
  CONSULTANCY: 'Consultoria',
  COVENANCE: 'Convênio',
};
